import { createContext } from "react";
import type { InstantSearchServerState } from "react-instantsearch";

export type SearchServerState = {
	query: string;
	indexName: string;
	state: InstantSearchServerState;
};

export const SearchServerStateContext = createContext<
	SearchServerState | undefined
>(undefined);
